import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type GlobalState = {
    trackingData: any;
    trackingStyle: any;
};
const initialState: GlobalState = {
    trackingData: null,
    trackingStyle: null,
};
// Action =====================================================
const analyticSlice = createSlice({
    name: 'analytic',
    initialState,
    reducers: {
        setTrackingData(state, action: PayloadAction<any>) {
            state.trackingData = action.payload;
        },
        setTrackingStyle(state, action: PayloadAction<any>) {
            state.trackingStyle = action.payload;
        },
    },
});

export const { setTrackingData, setTrackingStyle } = analyticSlice.actions;
const analyticReducer = analyticSlice.reducer;
export default analyticReducer;
